<horizon-profile-toolbar (logoutEvent)="logout()"></horizon-profile-toolbar>

<div class="flex flex-column">
  <h4 class="flex self-center" data-cy="no-profil-title">
    Aucun profil disponible pour l'adresse e-mail {{ email }}
  </h4>
  <button mat-button (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    Se déconnecter
  </button>
</div>
